export const CHANGE_VIEW = 'ATG/CHANGE_VIEW';
export const REQUEST_COUPON_URL = 'ATG/REQUEST_COUPON_URL';
export const RECEIVE_COUPON_URL = 'ATG/RECEIVE_COUPON_URL';
export const RECEIVE_COUPON_URL_ERROR = 'ATG/RECEIVE_COUPON_URL_ERROR';
export const CLEAR_COUPONS = 'ATG/CLEAR_COUPONS';
export const REQUEST_QUICK_OVERVIEW = 'ATG/REQUEST_QUICK_OVERVIEW';
export const RECEIVE_QUICK_OVERVIEW = 'ATG/RECEIVE_QUICK_OVERVIEW';
export const RECEIVE_QUICK_OVERVIEW_ERROR = 'ATG/RECEIVE_QUICK_OVERVIEW_ERROR';
export const CLEAR_QUICK_OVERVIEW = 'ATG/CLEAR_QUICK_OVERVIEW';
export const CHANGE_CURRENT_BET = 'ATG/CHANGE_CURRENT_BET';
export const CLEAR_CURRENT_BET = 'ATG/CLEAR_CURRENT_BET';
export const SET_CURRENT_BET_PRESET_BASED_AT =
  'ATG/SET_CURRENT_BET_PRESET_BASED_AT';
export const REQUEST_SETTINGS = 'ATG/REQUEST_SETTINGS';
export const RECEIVE_SETTINGS = 'ATG/RECEIVE_SETTINGS';
export const RECEIVE_SETTINGS_ERROR = 'ATG/RECEIVE_SETTINGS_ERROR';
export const REQUEST_UPDATE_SETTINGS = 'ATG/REQUEST_UPDATE_SETTINGS';
export const RECEIVE_UPDATE_SETTINGS = 'ATG/RECEIVE_UPDATE_SETTINGS';
export const RECEIVE_UPDATE_SETTINGS_ERROR =
  'ATG/RECEIVE_UPDATE_SETTINGS_ERROR';
export const REQUEST_CREATE_MATHBET = 'ATG/REQUEST_CREATE_MATHBET';
export const RECEIVE_CREATE_MATHBET = 'ATG/RECEIVE_CREATE_MATHBET';
export const RECEIVE_CREATE_MATHBET_ERROR = 'ATG/RECEIVE_CREATE_MATHBET_ERROR';

// wizard

export const REQUEST_WIZ_SYSTEMS = 'REQUEST_WIZ_SYSTEMS';
export const RECEIVE_WIZ_SYSTEMS = 'RECEIVE_WIZ_SYSTEMS';
export const RECEIVE_WIZ_SYSTEMS_ERROR = 'RECEIVE_WIZ_SYSTEMS_ERROR';

export const REQUEST_WIZ_SETTINGS = 'REQUEST_WIZ_SETTINGS';
export const RECEIVE_WIZ_SETTINGS = 'RECEIVE_WIZ_SETTINGS';
export const RECEIVE_WIZ_SETTINGS_ERROR = 'RECEIVE_WIZ_SETTINGS_ERROR';
